import { TextField } from '@components/Form/Field';
import { jsx, tscope } from '@i18n/index';
import React from 'react';
import {
  Text,
  Card,
  Flex,
  Button,
  CardBody,
  useDisclosure,
  Heading,
  Box,
} from 'ui';
import { Secure } from '@assets/images';
import { ClabeModal } from './components/ClabeModal';
import { useController } from './hooks';
import { style as s } from './Clabe.style';

export const ts = tscope('Documents.CLABE');

export const Clabe = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    control,
    onSubmit,
    isSubmitting,
  } = useController();

  return (
    <Flex {...s.container}>
      <ClabeModal isOpen={isOpen} onClose={onClose} />
      <Heading {...s.heading}>
        {ts('title')}
      </Heading>
      <Card as="form">
        <CardBody
          {...s.form}
        >
          <Text {...s.description}>
            {ts('description')}
          </Text>
          <TextField
            name="clabe"
            data-testid="clabeField"
            control={control}
            labelText={ts('label')}
            maxLength={18}
          />
          <Button
            variant="link"
            onClick={onOpen}
            {...s.whatIsClabe}
          >
            {ts('whatIsCLABE')}
          </Button>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <Flex {...s.secureDataContainer}>
            <Box {...s.secureDataBox}>
              <Secure {...s.secureDataImage} />
            </Box>
            <Text data-testid="secureData">
              {jsx('secureDataInfo', {
                t: ts,
                bold: (
                  <Text as="span" fontWeight="bold">
                    {ts('secureDataBold')}
                  </Text>
                ),
              })}
            </Text>
          </Flex>
        </CardBody>
      </Card>
      <Button
        {...s.submit}
        onClick={onSubmit}
        isLoading={isSubmitting}
      >
        {ts('continue')}
      </Button>
    </Flex>
  );
};
